import MobilePanelWrapper from './MobilePanelWrapper';

export default MobilePanelWrapper;